import {CreateInstance} from './config'
const deviceAPI = CreateInstance('devices')
export default deviceAPI
